import styled from 'styled-components'
import { COLOR } from '../../../assets/constants/constants'

const { secondary, quaternary } = COLOR;

export const StyledMain = styled.div`
`;

export const BackButton = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  cursor: pointer;
  margin-bottom: 8px;
  font-family: 'Amorim Sans Book';
  font-size: 18px;
  color: ${secondary};
  transition: all .2s ease-out;

  &:hover {
    color: ${quaternary};
    svg {
      margin-right: 12px;
      color: ${quaternary};
    }
  }

  svg {
    width: 14px;
    margin-right: 10px;
    color: ${secondary};
    fill: ${secondary};
    transition: all .2s ease-out;

    &.drone-icon{
      width: 24px;
    }
  }
`

export const SessionTitleContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 48px;
`

export const SessionTitle = styled.p`
  font-family: 'Amorim Sans Serif';
  font-size: 22px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  color: ${secondary};
`


